import { createStore } from 'zustand/vanilla';

type CookieConsentState = {
	updated?: boolean;
	allowFunctional: boolean;
	allowNecessary: boolean;
	allowMarketing: boolean;
	allowUnclassified: boolean;
	allowStatistics: boolean;
};

type CookieConsentActions = {
	setCookieConsent: (cookieConsent: CookieConsentState) => void;
};

export const cookieConsentStateStore = createStore<CookieConsentState & CookieConsentActions>((set) => ({
	updated: false,
	allowFunctional: false,
	allowNecessary: false,
	allowMarketing: false,
	allowUnclassified: false,
	allowStatistics: false,
	setCookieConsent: (cookieConsent: CookieConsentState) => set({ ...cookieConsent }),
}));
